'use client';

import Image from 'next/image';
import Icon from '@/components/ui/AppIcon';

export default function PartnershipSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center px-4 py-2 bg-brand-primary/10 text-brand-primary rounded-full mb-4">
            <Icon name="AcademicCapIcon" size={20} className="mr-2" />
            <span className="font-semibold">New Partnership</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
            USC GCSP Vertical Farm Project
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Partnering with USC Viterbi School of Engineering to develop innovative vertical farm prototypes that will teach K-12 students hands-on lessons in computer science, biology, and agriculture while combating food insecurity.
          </p>
        </div>

        {/* Project Image */}
        <div className="mb-12 rounded-xl overflow-hidden shadow-lg">
          <div className="relative w-full h-96">
            <Image
              src="/assets/images/Screenshot_2026-02-01_at_2.15.17_PM-1769973326930.png"
              alt="USC GCSP Vertical Farm Project graduation ceremony with students and faculty"
              fill
              className="object-cover"
              unoptimized
            />
          </div>
        </div>

        {/* Project Overview */}
        <div className="mb-12 bg-surface rounded-xl p-8">
          <h3 className="text-2xl font-bold text-text-primary mb-4 flex items-center">
            <Icon name="LightBulbIcon" size={24} className="mr-3 text-brand-primary" />
            Project Overview
          </h3>
          <p className="text-text-secondary mb-4">
            The non-profit organization, Food for Thought Foundation, is collaborating with USC Viterbi students to help develop and redesign a prototype for a vertical farm. When implemented, this vertical farm will be a tool to teach students hands-on lessons in computer science, biology, and agriculture.
          </p>
          <p className="text-text-secondary mb-4">
            As a viable device, this vertical farm will grow food that can be eaten and possibly help supplement food insecure environments.
          </p>
          <p className="text-text-secondary">
            Learn more about this partnership at the{' '}
            <a
              href="https://viterbiundergrad.usc.edu/gcsp/programs/gcsp-verticalfarm/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-primary hover:text-brand-secondary font-semibold underline inline-flex items-center"
            >
              USC GCSP website
              <Icon name="ArrowTopRightOnSquareIcon" size={16} className="ml-1" />
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
}